import React from "react";
import { useSelector } from "react-redux";
import PageLayout from "../components/Common/PageLayout";
import PageBanner from "../components/Common/PageBanner";

const Benefitsmembership = () => {
  const state = useSelector((state) => state);
  const pageContents = state?.pageContents;
  const membershipData = pageContents?.membership?.data;

  // Prepare banner props in a safe way to prevent errors
  const bannerProps = {
    bannerImage: membershipData?.membershipbanner?.banner_image || "",
    mainTitle: "Membership",
    pageTitle:
      membershipData?.membershipbanner?.banner_title ||
      "Benefits of Membership",
  };

  return (
    <PageLayout pageName="Benefits of Membership">
      {/* Render banner with explicit props */}
      {PageBanner(bannerProps)}

      <div className="how-its-work ptb-100">
        <div className="container">
          <div className="section-title bene-title">
            <h2>{membershipData?.membershipbenefit?.benefit_title}</h2>
            <p>{membershipData?.membershipbenefit?.benefit_short_desc}</p>
          </div>

          <div className="row ">
            <div className="col-lg-6" style={{ marginRight: "20px" }}>
              <div className="how-its-work-content bene-wrap-content">
                <div className="content-wrap bene-wrap">
                  <h3>
                    {membershipData?.membershipbenefit?.benefit_details_one}
                  </h3>
                </div>

                <div className="content-wrap bene-wrap">
                  <h3>
                    {membershipData?.membershipbenefit?.benefit_details_second}
                  </h3>
                </div>

                <div className="content-wrap bene-wrap">
                  <h3>
                    {membershipData?.membershipbenefit?.benefit_details_third}
                  </h3>
                </div>

                <div className="content-wrap bene-wrap">
                  <h3>
                    {membershipData?.membershipbenefit?.benefit_details_forth}
                  </h3>
                </div>
                <div className="content-wrap bene-wrap">
                  <h3>
                    {membershipData?.membershipbenefit?.benefit_details_fifth}
                  </h3>
                </div>
                <div className="content-wrap bene-wrap">
                  <h3>
                    {membershipData?.membershipbenefit?.benefit_details_six}
                  </h3>
                </div>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="how-work-img">
                <img src={membershipData?.membershipbenefit?.image} alt="[]" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default Benefitsmembership;
